import React from "react";

/**
 * Generic error boundary for embedded 3rd-party widgets (Spotify, TikTok, Instagram, YouTube).
 * Prevents a CDN throw (e.g. Spotify RangeError) from crashing the whole React tree.
 */
export default class EmbedErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Don't spam console; only log first occurrence per session
    if (typeof window !== "undefined" && !window.__embed_err_logged) {
      // eslint-disable-next-line no-console
      console.warn(`[Embed] ${this.props.label || "widget"} failed:`, error?.message || error);
      window.__embed_err_logged = true;
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}
